// Invoices page pieces for Time & Materials close-out invoices (slice 1d). Each renders NOTHING
// for an invoice that is not on a T&M order, so a fixed-price invoice's page is unchanged.
import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { isTmLinked } from '../../utils/tmPricing';

/** Why Edit and Void/Delete are gone on a T&M close-out invoice. */
export function TmInvoiceLockNote({ invoice }) {
  if (!isTmLinked(invoice)) return null;
  return (
    <Box data-testid="tm-invoice-lock" sx={{ mt: 2, p: 1.5, backgroundColor: 'rgba(13,202,240,0.12)', border: '1px solid rgba(13,202,240,0.4)', borderRadius: 1 }}>
      <Typography variant="body2">
        <b>Time &amp; Materials close-out invoice.</b> Its lines and total come from the price approved on the
        Sales Order, so Edit and Void/Delete are locked. Payments, PDF, email and Bill.com work as usual.
        To change the price, call Mike.
      </Typography>
    </Box>
  );
}

export default TmInvoiceLockNote;
